<script setup>
import { vMaska } from 'maska/vue';
import CmprInput from '@cta/frontend/components/CmprInput.vue';

const iban = defineModel('iban', { type: String });
const rawIban = defineModel('rawIban', { type: String });

const maskaConfig = {
  mask: 'LLAA AAAA AAAA AAAA AAAA AAAA AAAA AAAA AA',
  tokens: {
    A: {
      pattern: /[A-Z0-9]/,
      transform: (chr) => chr.toUpperCase(),
    },
    L: {
      pattern: /[A-Z]/,
      transform: (chr) => chr.toUpperCase(),
    },
  },
};

function updateIban(event) {
  iban.value = event.detail.masked;
  rawIban.value = event.detail.unmasked;
}

</script>

<template>
  <CmprInput
    v-maska="maskaConfig"
    placeholder="IBAN"
    @maska="updateIban"
  />
</template>
